import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=645b22e4&scoped=true&"
import script from "./Trading.vue?vue&type=script&lang=ts&"
export * from "./Trading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b22e4",
  null
  
)

export default component.exports